import React from 'react';
import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';

import { SmallSectionHeader } from 'components/Typography';
import {
  StyledCaption,
  StyledShortBody,
  StyledPaper,
} from 'components/MyContractInfo/styles';
import messages from 'components/MyContractInfo/EPARGNContractInfo/messages';
import { isReverse, translate } from 'helpers/intl';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EPARGN_PRODUCT_SCR } from 'constants/globalConstants';
export interface EPARGNContractInfoType {
  intl: IntlShape;
  numContract: string;
  dateEffet: string;
  souscripteur: string;
  EpargnBrute: string;
  dateSituation: string;
  numMembership: string;
  ppr: string;
  product?: number;
}
const EPARGNContractInfo = (props: EPARGNContractInfoType) => {
  const {
    numContract,
    dateEffet,
    souscripteur,
    dateSituation,
    EpargnBrute,
    numMembership,
    ppr,
    product,
  } = props;

  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <StyledPaper>
      <Box padding={3}>
        <Grid container spacing={matches ? 2 : 8}>
          <Grid item xs={matches ? 12 : 4}>
            <Grid container direction={matches ? 'row' : 'column'}>
              <Grid item xs={matches ? 6 : 12}>
                <StyledCaption>
                  {translate(get(messages, 'numContract'), props)}
                </StyledCaption>
              </Grid>
              <Grid item xs={matches ? 6 : 12}>
                <Box marginBottom={2}>
                  <StyledShortBody>{numContract}</StyledShortBody>
                </Box>
              </Grid>
              <Grid item xs={matches ? 6 : 12}>
                <StyledCaption>
                  {translate(get(messages, 'dateEffet'), props)}
                </StyledCaption>
              </Grid>
              <Grid item xs={matches ? 6 : 12}>
                <StyledShortBody>{dateEffet}</StyledShortBody>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={matches ? 12 : 4}>
            <Grid container direction={matches ? 'row' : 'column'}>
              <Grid item xs={matches ? 6 : 12}>
                <StyledCaption>
                  {translate(get(messages, 'souscripteur'), props)}
                </StyledCaption>
              </Grid>
              <Grid item xs={matches ? 6 : 12}>
                <Box marginBottom={2}>
                  <StyledShortBody>{souscripteur}</StyledShortBody>
                </Box>
              </Grid>
              {!isEmpty(numMembership) && (
                <>
                  <Grid item xs={matches ? 6 : 12}>
                    <StyledCaption>
                      {translate(get(messages, 'membershipNumber'), props)}
                    </StyledCaption>
                  </Grid>
                  <Grid item xs={matches ? 6 : 12}>
                    <StyledShortBody>{numMembership}</StyledShortBody>
                  </Grid>
                </>
              )}
              {!isEmpty(ppr) && (
                <>
                  <Grid item xs={matches ? 6 : 12}>
                    <StyledCaption>
                      {translate(get(messages, 'ppr'), props)}
                    </StyledCaption>
                  </Grid>
                  <Grid item xs={matches ? 6 : 12}>
                    <StyledShortBody>{ppr}</StyledShortBody>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={matches ? 12 : 4}>
            <Grid container direction={matches ? 'row' : 'column'}>
              <Grid item>
                <StyledCaption reverse={reverse}>
                  {product === EPARGN_PRODUCT_SCR
                    ? translate(get(messages, 'capitalGaranti'), props)
                    : translate(get(messages, 'EpargnBrute'), props)}
                  <span>{dateSituation}</span>
                </StyledCaption>
              </Grid>
              <Grid item dir="ltr">
                <Box marginBottom={2}>
                  <SmallSectionHeader color="#6FAD37">
                    {EpargnBrute}
                  </SmallSectionHeader>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default injectIntl(EPARGNContractInfo);
